import { render } from "./changeRoom.vue?vue&type=template&id=631f46ba&scoped=true"
import script from "./changeRoom.vue?vue&type=script&lang=js"
export * from "./changeRoom.vue?vue&type=script&lang=js"

import "./changeRoom.vue?vue&type=style&index=0&id=631f46ba&scoped=true&lang=css"

import exportComponent from "E:\\项目\\chesscards_5.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-631f46ba"]])

export default __exports__